import React from "react"
import HomePage from "../homePage/HomePage"

const NoLoginPage = () => {
	return <HomePage />
}

export default NoLoginPage
